export class SuspectedCondition {
    displayAlias: string;
    condition: string;
    baseQuestionCode: string;
    description: string;

    constructor() {
        this.displayAlias = '';
        this.condition = '';
        this.baseQuestionCode = '';
        this.description = '';
    }
}
